export const enum ProgramAttributes {
    NAME = 'name',
    PROGRAMTYPE = 'programType',
    OWNER = 'owner',
    SUBSCRIBER = 'subscriber',
    CARRIER = 'carrier',
    RECEIVER = 'receiver',
    CUSTOMER = 'customer',
}

export type OrgFieldAttribute =
    | ProgramAttributes.SUBSCRIBER
    | ProgramAttributes.CARRIER
    | ProgramAttributes.RECEIVER
    | ProgramAttributes.CUSTOMER

export const ORG_FIELD_IDS: OrgFieldAttribute[] = [
    ProgramAttributes.SUBSCRIBER,
    ProgramAttributes.CARRIER,
    ProgramAttributes.RECEIVER,
    ProgramAttributes.CUSTOMER,
]

export const pickerTitleKeys: Record<OrgFieldAttribute, string> = {
    [ProgramAttributes.SUBSCRIBER]: 'manageShippers',
    [ProgramAttributes.CARRIER]: 'manageCarriers',
    [ProgramAttributes.RECEIVER]: 'manageReceivers',
    [ProgramAttributes.CUSTOMER]: 'manageCustomers',
}

export const orgFieldLabelKeys: Record<OrgFieldAttribute, string> = {
    [ProgramAttributes.SUBSCRIBER]: 'shipper',
    [ProgramAttributes.CARRIER]: 'carrier',
    [ProgramAttributes.RECEIVER]: 'receiver',
    [ProgramAttributes.CUSTOMER]: 'customer',
}
